import { Component, OnInit } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ChangeLogItem} from '../model/change-log-item';
import {BaseActions} from '../shared/base-actions';
import {takeUntil} from 'rxjs/operators';

@Component({
  selector: 'app-change-log',
  templateUrl: './change-log.component.html',
  styleUrls: ['./change-log.component.less']
})
export class ChangeLogComponent extends BaseActions implements OnInit {

  items: ChangeLogItem[] = [];

  constructor(private httpClient: HttpClient) {
    super();
    document.body.classList.add('disable-hidden-overflow');
  }

  ngOnInit() {
    this.httpClient.get<Array<ChangeLogItem>>('/assets/changelog.json').pipe(
      takeUntil(this.stopSubscription)
    ).subscribe((items: ChangeLogItem[]) => {
      this.items = items;
    });
  }

}
